import { render, staticRenderFns } from "./RhombusSplitIcon.vue?vue&type=template&id=daff9e7a"
import script from "./RhombusSplitIcon.vue?vue&type=script&lang=js"
export * from "./RhombusSplitIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports